import { render } from "./InspectionCard.vue?vue&type=template&id=2bc9dc05&scoped=true&lang=pug"
import script from "./InspectionCard.vue?vue&type=script&lang=ts"
export * from "./InspectionCard.vue?vue&type=script&lang=ts"

import "./InspectionCard.vue?vue&type=style&index=0&id=2bc9dc05&lang=sass&scoped=true"
script.render = render
script.__scopeId = "data-v-2bc9dc05"

export default script